import React, { useState, useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import {
  fetchFormulasByRepresentante,
  setPage,
  clearAll,
} from '../../stores/representanteFormulaListActions';
import Title from '../../components/Title';
import Skeleton from 'react-loading-skeleton';
import Row from '../../components/Row';
import Grid from '../../components/Grid';
import FormulaList from './FormulaList';
import Pagination from '../../components/Pagination';

export default function FormulasRepresentanteListContainer() {
  const [isLoading, setLoading] = useState(true);
  const [isFirst, setFirst] = useState(true);

  const dispatch = useDispatch();

  const formulas = useSelector((state) => state.representante.formula.formulas);
  const usuarioId = useSelector((state) => state.auth.user.usu_in_codigo);

  const page = useSelector(
    (state) => state.representante.formula.pagination.page
  );
  const itemsPerPage = useSelector(
    (state) => state.representante.formula.pagination.itemsPerPage
  );
  const totalItems = useSelector(
    (state) => state.representante.formula.pagination.totalItems
  );

  const farmaciaId = localStorage.getItem('FORMULARIO_FARMACIA_ID');

  useEffect(() => {
    dispatch(
      fetchFormulasByRepresentante(farmaciaId, usuarioId, {
        page: 1,
        itemsPerPage,
      })
    );

    return () => dispatch(clearAll());
  }, []);

  useEffect(() => {
    if (!isFirst) setLoading(false);
    else setFirst(false);
  }, [formulas]);

  function handlePaginate(pgNumber) {
    if (pgNumber === page) return;

    setLoading(true);

    dispatch([
      setPage(pgNumber),
      fetchFormulasByRepresentante(farmaciaId, usuarioId, {
        page: pgNumber,
        itemsPerPage,
      }),
    ]);
  }

  return (
    <div className='formula-container'>
      <Title link='/'>Listagem de formulas</Title>

      <Row>
        <Grid cols='12'>
          {isLoading ? (
            <Skeleton count={5} height={30} />
          ) : (
            <FormulaList formulas={formulas} />
          )}
        </Grid>
      </Row>

      {formulas.length > 0 ? (
        <Row>
          <Grid cols='12'>
            <Pagination
              page={page}
              itemsPerPage={itemsPerPage}
              totalItems={totalItems}
              paginate={handlePaginate}
            />
          </Grid>
        </Row>
      ) : null}
    </div>
  );
}
